// import Swiper JS
import Swiper from 'swiper/bundle';

// import Swiper styles
import 'swiper/swiper-bundle.css';
import WaypointTrigger from '../../component/waypoint_initializer';

export default class XLTileLiteCarousel {
    constructor(el) {
        this.el = el;
        this.selectors = {
            rootEle: '.xl-tile-lite',
            swiperContainer: '.xl-tile-light-swiper-container',
            pagination: '.swiper-pagination',
            nextControlEle: '.swiper-button-next',
            preControlEle: '.swiper-button-prev',
            videoTrigger: '.video-trigger',
            videobtn: '.youtube-close',
        };
        this.classes = {
            pageClick: 'swiper-pagination-clickable',
            bulletActive: 'is--active',
            bullet: 'page-dot',
        };
        this.xlTiles = [...el.querySelectorAll('.xl-tile-lite')];
        this.first = this.xlTile(this.xlTiles[0]);
        this.xlTileslength = this.xlTiles.length;
        this.bind();
        this.init();
    }

    xlTile(el) {
        return {
            el,
            youtubeBg: el?.querySelector('.xl-tile-lite-bg-yt-video'),
            vimeo: el?.querySelector('.xl-tile-lite-vimeo-player'),
            hasVideo() { return !!(this.youtubeBg || this.vimeo); },
        };
    }

    swiperMobileCss() {
        const self = this;
        const mobile = window.matchMedia('(min-width: 0px) and (max-width: 800px)');
        const swiperPrev = self.el.querySelector('.swiper-button-prev');
        const swiperNext = self.el.querySelector('.swiper-button-next');
        if (mobile.matches || this.xlTileslength <= 1) {
            swiperPrev.style.display = 'none';
            swiperNext.style.display = 'none';
        } else {
            swiperPrev.style.removeProperty('display');
            swiperNext.style.removeProperty('display');
        }
    }

    bind() {
        this.el.addEventListener('visible', () => {
            this.swiper.autoplay.start();
        });

        this.xlTiles.forEach((xlTile) => {
            const youtube = xlTile.querySelector('.xl-tile-lite-youtube-player');
            if (youtube) {
                xlTile.addEventListener('youtube-video-playing', (e) => this.swiper.autoplay.stop());
                xlTile.addEventListener('youtube-video-stop', (e) => this.swiper.autoplay.start());

                const ytVdoPlayBtn = xlTile?.querySelector('.video-button');
                ytVdoPlayBtn?.addEventListener('click', () => this.swiper.autoplay.stop());
                xlTile.querySelector('.youtube-close').addEventListener('click', () => this.swiper.autoplay.start());
            }
        });
    }

    disableNonActiveSlides(swiper) {
        swiper.slides.forEach((slide, index) => {
            if(index === swiper.activeIndex) {
                slide.ariaHidden = false;
                slide.removeAttribute('inert');
            } else {
                slide.ariaHidden = true;
                slide.setAttribute('inert', '');
            }
        });
    }

    init() {
        const self = this;
        const { loopinterval, isautoloopenabled } = self.el.dataset;
        const mobile = window.matchMedia('(min-width: 0px) and (max-width: 800px)');

        self.autoplay = {
            delay: loopinterval || 8000,
            disableOnInteraction: true,
            pauseOnMouseEnter: false,
            stopOnLastSlide: isautoloopenabled !== 'true',
        };

        self.pagination = {
            el: self.selectors.pagination,
            type: 'bullets',
            bulletClass: self.classes.bullet,
            bulletActiveClass: self.classes.bulletActive,
            clickableClass: self.classes.pageClick,
            clickable: true,
            renderBullet(index, className) {
                return `<a class='${className}' href="#" data-index="${ index }"><div class='circle'><div class='halfclip'><div class='halfcircle clipped'></div></div><div class='halfcircle fixed'></div></div></a>`;
            },
        };
        self.swiper = new Swiper(self.el, {
            init: true,
            direction: 'horizontal',
            autoplay: self.autoplay,
            speed: 500,
            loop: (isautoloopenabled == 'true'),
            navigation: (mobile.matches || this.xlTileslength <= 1) ? false : {
                nextEl: self.selectors.nextControlEle,
                prevEl: self.selectors.preControlEle,
            },
            pagination: (this.xlTileslength <= 1) ? false : self.pagination,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            on: {
                init(event) {
                    self.swiperMobileCss();
                    self.disableNonActiveSlides(event);
                },
                resize() {
                    self.swiperMobileCss();
                },
                loopFix() {
                    HONDA.ModuleLoader.update();
                },
                slideChange(event) {
                    self.disableNonActiveSlides(event);
                },
            },
        });

        self.swiper.autoplay.stop();

        self.swiper.on('slideChange', () => {
            const slide = self.swiper.slides[self.swiper.activeIndex];
            const ytVdoPlayBtn = slide?.querySelector('.video-button');
            const ytCloseBtn = slide?.querySelector('.youtube-close');
            ytVdoPlayBtn?.addEventListener('click', () => self.swiper.autoplay.stop());
            ytCloseBtn?.addEventListener('click', () => self.swiper.autoplay.start());
        });

        if (self.first.hasVideo()) {
            self.swiper.autoplay.stop();
        }

        const waypointTriggers = new WaypointTrigger();
        waypointTriggers.init();
    }
}
